
  import { defineComponent } from 'vue';

  import constants from '@/common/constants';

  import AdditionalUploadingTemplate from '../components/additional-uploading/AdditionalUploadingTemplate.vue';
  import { UploadingDataStatusTypes } from '../types/calculation-common';

  export default defineComponent({
    name: 'AdditionalGasUploading',
    components: {
      AdditionalUploadingTemplate,
    },
    computed: {
      getPermissionCode() {
        return constants.Permissions.VedAdditionalGasUploadingView;
      },
      getType(): UploadingDataStatusTypes {
        return UploadingDataStatusTypes.ADDITIONAL_GAS_UPLOADING;
      },
    },
  });
